import { useNavigate } from "react-router-dom";
import VariantAccordion from "../Users/VariantAccordion";

function OtherProductsVisual(props: any) {
    console.log(props);
    //console.log("this is a brand, ",props.brand);
    const navigate = useNavigate();

    function goToDetailsHandler(id: string) {
        navigate(`/product/${id}`);
    }
    return (
        <div style={{marginTop:"25px"}}>
            <div className="variants_section">
                <h3 >Browse product variants </h3>
                <div className="variant_section" style={{ margin: "auto" }}>
                    {props.variants.map((el: { id: string; title: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | null | undefined; thumbnail: string | undefined; }) => {
                        return (
                            <div className={`variant_element ${props.selected === el.id ? "active_variant" : ""}`} key={el.id} onClick={() => goToDetailsHandler(el.id)} >
                                <img className="variant_img" src={el.thumbnail} alt="product-variant" height="60px" width="60px"

                                    onError={({ currentTarget }) => {
                                        currentTarget.onerror = null; // prevents looping
                                        currentTarget.src = "../img/no-img.png";
                                    }}
                                />
                                <p className="variant_title">{el.title}</p>
                            </div>
                        )
                    })}
                </div></div>
        </div>
    );
}
export default OtherProductsVisual;